export default __webpack_public_path__ + "static/media/WNLProtoIpad.522fac3b.png";